<template>
    <div class="page-class"
        :class="[{'page-mass': theme == 'mass'}, {'page-prestige': theme == 'prestige'}]">
        <div v-if="isAccountLoaded">
            <AIAHeaderText
                :modalController="modalController"
                :headerText="lbl.faq.headline"
                @clickBack="clickBack" />

            <div class="static-content">
                <FaqItem
                    v-for="(question, k) in questions"
                    :key="k"
                    :question="question" />
            </div>
        </div>

        <modal-master :controller="modalController"></modal-master>
    </div>
</template>
<script>
//mixin
import AccountMixin from "@/mixin/AccountMixin.js";
import ErrorApiMixin from "@/mixin/ErrorApiMixin.js";
import LocaleMixin from "@/mixin/LocaleMixin.js";
//layout
import AIAHeaderText from "@/components/Layout/header/AIAHeaderText.vue";
//component
import FaqItem from "../component/faq/FaqItem.vue";
//modal
import ModalMaster from "@/components/Modal/Component/ModalMaster.vue";
import ModalFactory from "@/components/Modal/ModalFactory.js";
export default {
    name: 'Faq',
    components: {
        //layout
        AIAHeaderText,
        //component
        FaqItem,
        //modal
        ModalMaster
    },
    mixins: [AccountMixin, LocaleMixin, ErrorApiMixin],
    data: function () {
        return {
            pageName: 'faq',
            questions: [],
        };
    },
    created: function () {
        this.initialModal();
    },
    methods: {
        //mixin
        accountInitiated: function () {
            this.questions = (this.theme == 'mass')
                            ? this.lbl.faq.mass_question
                            : this.lbl.faq.prestige_question;
        },
        //event
        clickBack: function () {
            this.$router.back();
        },
        //modal
        initialModal: function () {
            var modalFactory = new ModalFactory();
            this.modalController = modalFactory.getModalController();
            this.alertModal = modalFactory.getAlertModal();
            this.loadingModal = modalFactory.getLoadingModal();
            this.noInternetModal = modalFactory.getNoInternetModal();
        }
    }
}
</script>
<style lang="scss">
@import "./Static.scss";
</style>
